import React from "react";

export interface CollapsibleProps {
  title: string;
  titleHi?: string;
  badge?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  headingLevel?: "h2" | "h3";
}

export function Collapsible({
  title,
  titleHi,
  badge,
  defaultOpen = false,
  children,
  className = "",
  headerClassName = "",
  contentClassName = "",
  headingLevel = "h3",
}: CollapsibleProps) {
  const Heading = headingLevel;
  return (
    <details open={defaultOpen || undefined} className={`mb-6 group ${className}`}>
      <summary
        className={`card-sacred p-4 cursor-pointer select-none flex items-center justify-between transition group-open:bg-ish-accent-light/30 ${headerClassName}`}
        style={{ listStyle: "none" }}
      >
        <div className="flex items-center gap-3">
          <Heading className="text-lg font-semibold text-ish-dark font-serif">
            {title}
            {/* Hindi, so an English page's voice does not read it (WCAG 3.1.2);
                the secondary role keeps it AA, where opacity-60 fell to 4.45:1. */}
            {titleHi && (
              <span lang="hi" className="ml-2 text-sm font-normal text-text-secondary">
                ({titleHi})
              </span>
            )}
          </Heading>
          {badge}
        </div>
        <svg
          className="w-5 h-5 flex-shrink-0 transition-transform group-open:rotate-180 text-ish-faint"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </summary>
      <div className={`mt-2 ${contentClassName}`}>{children}</div>
    </details>
  );
}
